export const TEST_ID = 'ringGauge';

export const RING_CIRCUMFERENCE = 150.8;

export const RING_MAX_PERCENT = 100;

export const RING_VIEWBOX = '0 0 56 56';

export const RING_CENTER = 28;

export const RING_RADIUS = 24;

export const RING_STROKE_WIDTH = 4;
